const config = {
  apiUrl: "https://api.choosereach.com",
  releaseStage: "development"
};

export default config;
